import React, { FC } from 'react';
import { useAuth } from 'providers/useAuth/AuthContext';
import { StyledButtonPlay } from 'components/Cards/Card/Card.css';

type PropTypes = {
    visible?: boolean;
    onPlay?: (e: React.MouseEvent) => void;
};

export const CardPlayButton: FC<PropTypes> = ({ visible, onPlay }) => {
    const { isInhibited } = useAuth();

    if (!visible || isInhibited) {
        return null;
    }

    return (
        <StyledButtonPlay
            onClick={(e) => {
                e.stopPropagation();
                onPlay(e);
            }}
        />
    );
};
